import { useMemo, useState } from 'react';

import { EntityRefUtil, InspectionDTO } from '@gearbelt/global';
import dayjs from 'dayjs';

import documentsVector from '@/assets/vectors/documents.svg';
import { ListItem } from '@/awa-pages/[workspaceId]/assets/[id]/inspections/list-item';
import InspectionDrawer from '@/components/inspections/inspection-drawer';

export function AWAInspectionsList({ inspections = [], assetId: _assetId }: { inspections: InspectionDTO[]; assetId: string }) {
  const [isInspectionDrawerOpen, setIsInspectionDrawerOpen] = useState(false);
  const [selectedInspection, setSelectedInspection] = useState<InspectionDTO | null>(null);

  const groupedInspections = useMemo(() => {
    const groups: Record<string, InspectionDTO[]> = {};

    inspections?.forEach((inspection: InspectionDTO): void => {
      const dateKey: string = dayjs(inspection.inspectionDate).format('MMM DD, YYYY');
      if (!groups[dateKey]) {
        groups[dateKey] = [];
      }
      groups[dateKey].push(inspection);
    });

    return groups;
  }, [inspections]);

  /* No Inspection forms yet */
  if (inspections.length === 0) {
    return (
      <div className="flex h-full w-full flex-col items-center gap-2 px-2 py-25">
        <img src={documentsVector} alt="No issues yet" className="h-[170px] w-[250px]" />
        <div className="text-default-text text-center text-xl font-medium">No records yet</div>
        <div className="text-secondary-text text-center text-base font-normal">Tap the green button to get started.</div>
      </div>
    );
  }

  return (
    <>
      {Object.entries(groupedInspections).map(([date, inspections]) => (
        <div key={date}>
          <div className="bg-grey-2 flex h-[28px] w-full flex-row items-center gap-1 p-1">
            <div className="text-default-text text-sm font-medium">{date}</div>
          </div>
          <div className="flex w-full flex-col items-start gap-4 p-4">
            {inspections.map((inspection: InspectionDTO) => (
              <ListItem
                key={inspection.id}
                inspectionId={inspection.id}
                contactFullName={EntityRefUtil.createUserFullNameRef(inspection.inspectedBy)}
                createdAt={new Date(inspection.inspectionDate)}
                onClick={() => {
                  setSelectedInspection(inspection);
                  setIsInspectionDrawerOpen(true);
                }}
              />
            ))}
          </div>
        </div>
      ))}

      <InspectionDrawer noTrigger inspectionId={selectedInspection?.id} open={isInspectionDrawerOpen} onOpenChange={setIsInspectionDrawerOpen} />
    </>
  );
}
